export const Hero = () => (
	<section
		className="relative w-full min-h-[520px] md:min-h-[600px] overflow-hidden flex items-center justify-center"
		style={{ margin: 0, padding: 0 }}
	>
		<div className="relative z-20 w-screen mx-auto flex flex-col items-center justify-center py-8 animate-fadeIn min-h-[520px] md:min-h-[600px]">
			<div className="absolute inset-0 flex items-center justify-center z-0">
				<div
					className="w-full h-full flex items-center justify-center"
					style={{ position: "relative" }}
				>
					<video
						src="/austin_hero_video_gova.mp4"
						className="absolute inset-0 w-screen h-full object-cover"
						autoPlay
						loop
						muted
						playsInline
						preload="metadata"
						style={{ objectPosition: "center center" }}
					/>
					{/* Dark overlay for text contrast */}
					<div
						style={{
							position: "absolute",
							inset: 0,
							background:
								"linear-gradient(120deg, rgba(0, 0, 0, 0.55) 0%, rgba(127, 127, 130, 0.45) 80%)",
							zIndex: 2,
							pointerEvents: "none",
						}}
					/>
					{/* White gradient fade at bottom: show for all screen sizes */}
					<div
						style={{
							position: "absolute",
							left: 0,
							right: 0,
							bottom: 0,
							height: "40%",
							background:
								"linear-gradient(to top, #fff 0%, rgba(194, 192, 192, 0) 100%)",
							zIndex: 3,
							pointerEvents: "none",
						}}
					/>
				</div>
			</div>

			{/* Logo and Text overlapping video, perfectly centered */}
			<div className="absolute inset-0 flex flex-col items-center justify-center z-10 pointer-events-none px-2">
				<img
					src="/gova_logo.png"
					alt="Gova Engineering Logo"
					width="512"
					height="512"
					className="h-40 w-auto mb-8 pointer-events-auto 2xl:h-[180px]"
				/>
				<h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white text-center mb-4 max-w-3xl">
					Civil Engineering &amp; Site Development in Central Texas
				</h1>
				<p className="text-base sm:text-lg md:text-xl text-white mb-6 max-w-lg w-full text-center pointer-events-auto font-light">
					Professional Civil Engineering Consulting and Design Services with
					expertise in Land Development including residential and commercial
					subdivision platting and design, site development plans, tap plans, septic system design, and more.
				</p>
				<div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mt-2 justify-center items-center pointer-events-auto">
					<a
						href="#contact"
						className="inline-flex items-center justify-center gap-2 bg-primary hover:bg-cyan-300 text-white font-bold rounded-md px-8 py-3 shadow-lg transition-colors uppercase tracking-wide border-2"
					>
						Request Project Quote
					</a>
					<a
						href="#services"
						className="inline-flex items-center justify-center gap-2 bg-white/90 hover:bg-white text-blue-900 font-bold rounded-md px-8 py-3 shadow-lg transition-colors uppercase tracking-wide border-2"
					>
						View Services
					</a>
				</div>
			</div>
		</div>

		{/* Fade-in animation keyframes */}
		<style>
			{`
							.animate-fadeIn {
							animation: fadeInHero 1.2s ease 0.05s both;
							}
							@keyframes fadeInHero {
							0% { opacity: 0; transform: translateY(30px);}
							100% { opacity: 1; transform: translateY(0);}
							}
						`}
		</style>
	</section>
);
